import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { WeathermapFacade } from '@store/weathermap.facade';
import { Station } from '@store/weathermap.store';
import { Point } from 'geojson';
import { GeoJSONFeature } from 'maplibre-gl';
import { LayersService } from 'src/app/services/layers.service';
import { STATION_ID_CACHE_KEY } from 'src/app/weathermap.const';

@Injectable({
  providedIn: 'root',
})
export class SelectedStationService {
  private readonly store = inject(Store);
  private readonly weathermapFacade = inject(WeathermapFacade);
  private readonly layersService = inject(LayersService);

  selectFeature(feature: GeoJSONFeature): void {
    const station = {
      ...feature.properties,
      modules: JSON.parse(feature.properties.modules),
    } as Station;
    const coordinates = (feature.geometry as Point).coordinates as number[];
    this.selectStation(station, coordinates);
  }

  selectStation(station: Station, coordinates: number[]): void {
    this.layersService.filterStation(station.id);

    const pinType = this.weathermapFacade.selectedPintype();
    window.map.getSource<maplibregl.GeoJSONSource>('selected-station').setData({
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          properties: {
            station: {
              ...station,
              modules: JSON.stringify(station.modules),
            },
            pinType,
          },
          geometry: {
            type: 'Point',
            coordinates,
          },
        },
      ],
    });

    localStorage.setItem(STATION_ID_CACHE_KEY, station.id);

    this.weathermapFacade.selectStation(station);
  }

  unselectStation(): void {
    this.layersService.unfilterStation();
    window.map.getSource<maplibregl.GeoJSONSource>('selected-station').setData({
      type: 'FeatureCollection',
      features: [],
    });

    localStorage.removeItem(STATION_ID_CACHE_KEY);

    this.weathermapFacade.selectStation(null);
  }
}
